var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.125C8.39517 3.125 7.09167 4.42851 7.09167 6.03335V8.125H5.84167V6.03335C5.84167 3.73815 7.70482 1.875 10 1.875C12.2952 1.875 14.1583 3.73815 14.1583 6.03335V8.125H12.9083V6.03335C12.9083 4.42851 11.6048 3.125 10 3.125Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.375C10.3451 12.375 10.625 12.6548 10.625 13V14.5C10.625 14.8452 10.3451 15.125 10 15.125C9.6548 15.125 9.375 14.8452 9.375 14.5V13C9.375 12.6548 9.6548 12.375 10 12.375Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.75C9.8297 11.75 9.69165 11.888 9.69165 12.0583C9.69165 12.2286 9.8297 12.3666 10 12.3666C10.1702 12.3666 10.3083 12.2286 10.3083 12.0583C10.3083 11.888 10.1702 11.75 10 11.75ZM8.44165 12.0583C8.44165 11.1977 9.13935 10.5 10 10.5C10.8607 10.5 11.5583 11.1977 11.5583 12.0583C11.5583 12.9189 10.8607 13.6166 10 13.6166C9.13935 13.6166 8.44165 12.9189 8.44165 12.0583Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66671 8.375C5.17096 8.375 3.95837 9.58755 3.95837 11.0834V14.1666C3.95837 15.6624 5.17096 16.875 6.66671 16.875H13.3334C14.8292 16.875 16.0417 15.6624 16.0417 14.1666V11.0834C16.0417 9.58755 14.8292 8.375 13.3334 8.375H6.66671ZM2.70837 11.0834C2.70837 8.8972 4.48058 7.125 6.66671 7.125H13.3334C15.5195 7.125 17.2917 8.8972 17.2917 11.0834V14.1666C17.2917 16.3528 15.5195 18.125 13.3334 18.125H6.66671C4.48058 18.125 2.70837 16.3528 2.70837 14.1666V11.0834Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cd4d48fbd0588435c2ed7a533b5f46c6.svg";
export { ForwardRef as ReactComponent };